import React, {useState} from 'react'
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import {ProgressSpinner} from "primereact/progressspinner";
import DHDialog from "../../../general/DHDialog";
import DHButtonDefault from "../../../general/DHButtonDefault";
import DHNumberTextField from "../../../general/DHNumberTextField";
import DHButtonSave from "../../../general/DHButtonSave";

export default function ErgebnisDialog({boardGame, onClose, onSuccess, onError}) {
    const [showProgressSpinner, setShowProgressSpinner] = useState(false);
    const [anzahlPlayer1, setAnzahlPlayer1] = useState("");
    const [anzahlPlayer2, setAnzahlPlayer2] = useState("");

    const ergebnisEintragen = (tmpAnzahlPlayer1, tmpAnzahlPlayer2) => {
        setShowProgressSpinner(true);
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.eventoperator + "/gameergebnis",
            {tournamentId: boardGame.tournamentId, tournamentGameId: boardGame.tournamentGameId, anzahlSpieler1: tmpAnzahlPlayer1, anzahlSpieler2: tmpAnzahlPlayer2},
            json => {
                onSuccess();
                setShowProgressSpinner(false);
            },
            responseNotOk => {
                onError("Fehler: " + responseNotOk.message);
                setShowProgressSpinner(false);
            },
            error => {
                onError("Fehler: " + error.message);
                setShowProgressSpinner(false);
            }
        );
    }

    return <DHDialog onClose={() => onClose()} title="Ergebnis eintragen" show={true}
                            comp={<>
                                <div style={{fontSize: 20, marginBottom: 10}}>{boardGame.gameDescription}</div>

                                {showProgressSpinner ?
                                    <ProgressSpinner style={{width: 100, height: 100}}/>
                                    :
                                    <>
                                        <div style={{display: "flex", marginBottom: 10}}>
                                            <DHButtonDefault label={"Spieler 1 gewonnen"} onClick={() => ergebnisEintragen("1", "0")}/>
                                            <DHButtonDefault label={"Spieler 2 gewonnen"} style={{marginLeft: 10}} onClick={() => ergebnisEintragen("0", "1")}/>
                                        </div>

                                        <div style={{display: "flex"}}>
                                            <DHNumberTextField id="id-anzahl-player1" label="" width={70} variant="standard"
                                                                min={0} max={100}
                                                               value={anzahlPlayer1} onChange={(text) => setAnzahlPlayer1(text)}/>
                                            <span style={{marginLeft: 5, marginRight: 5, fontSize: 25}}>:</span>
                                            <DHNumberTextField id="id-anzahl-player2" label="" width={70} variant="standard"
                                                               min={0} max={100}
                                                               value={anzahlPlayer2} onChange={(text) => setAnzahlPlayer2(text)}/>
                                            <DHButtonSave label="Speichern" onClick={() => ergebnisEintragen(anzahlPlayer1, anzahlPlayer2)}
                                                          disabled={anzahlPlayer1 === "" || anzahlPlayer2 === ""}/>
                                        </div>
                                    </>
                                }
                            </>}/>
}
